module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTABQ2ABR2gBS2QBR2gBS1wBQ1wBR2ABS2ABQ2gBS2R1dV9wAAAAKdFJOUwBeHuDCgECecDArGIwyAAAAZklEQVQI12NgwAlYXJxgTK7yRXBmEpyp5QJhqqUlmocGgZlRq1YVoBhSbNzAwDBREARchAMYGJqNQcCcJQCmoGoVkCni4iLAwDAtTYGBITU0fCFCe9QqhMWNCKYYgolQwKSkgOoBAEpHFpJ8yDWrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/wxpclit1.png
// module id = 3LjA
// module chunks = 1